<template>
  <div class="promos">
    <div class="coupons" v-if="coupons.length">
      <h4 class="promotitle f4">{{ $t('Coupons') }}</h4>
      <div class="grid">
        <div class="coupongroup checkboxgroup" v-for="coupon in coupons" :key="coupon.id">
          <label>
            <input type="checkbox" @change="$emit('couponAction', coupon)" :checked="isCouponSelected(coupon)">
            <span class="text f8">
              {{ coupon.code }} -
              <span v-if="coupon.type === 'percent'">{{ coupon.amount }}% {{ $t('Off') }}</span>
              <span v-else>{{ toLocationLocale(coupon.amount) }} {{ $t('Off') }}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="discounts" v-if="discounts.length">
      <h4 class="promotitle f4">{{ $t('Discounts') }}</h4>
      <div class="grid">
        <div class="discount-group checkboxgroup" v-for="discount in discounts" :key="discount.id">
          <label>
            <input type="checkbox" @change="$emit('discountAction', discount)" :checked="isDiscountSelected(discount)">
            <span class="text f8">{{ discount.code }} -
              <span v-if="discount.type === 'percent'">{{ discount.amount }}% {{ $t('Off') }}</span>
              <span v-else>{{ toLocationLocale(discount.amount) }} {{ $t('Off') }}</span></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    coupons: {
      type: Array,
      required: true,
    },
    discounts: {
      type: Array,
      required: true,
    },
    bookingStationTime: {
      type: Object,
      required: true,
    },
    locationId: {
      type: String,
      required: true,
    },
  },
})
export default class Promos extends Vue {
  isCouponSelected (coupon) {
    if (this.bookingStationTime.coupon) {
      return this.bookingStationTime.coupon.id === coupon.id;
    }
  }

  isDiscountSelected (discount) {
    if (this.bookingStationTime.discount) {
      return this.bookingStationTime.discount.id === discount.id;
    }
  }

  toLocationLocale (number) {
    return this.$store.getters.formatAsLocationCurrency({ locationId: this.locationId, number });
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.promos {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--spacingSm);

  @media (--tablet) {
    display: flex;
    align-items: flex-start;

    & > * {
      flex: 1 0 50%;
      margin-right: var(--spacingSm);
      &:last-child { margin-right: 0 }

      @media (--tablet) {
        margin-right: var(--spacingMd);
        &:last-child { margin-right: 0 }
      }

      @media (--desktop) {
        margin-right: var(--spacingLg);
        &:last-child { margin-right: 0 }
      }
    }
  }

  & h4 {
    &.promotitle {
      margin-bottom: var(--spacingSm);
    }

    @media (--tablet) {
      margin-top: 0;
    }
  }

  & label {
    display: block;
    margin: 0;
    position: relative;

    & .text {
      position: relative;
    }
  }

  & .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: var(--spacingSm);

    @media (--tablet) {
      grid-gap: var(--spacingMd);
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

</style>
